export const PRESERVED_QUERY_NAMESPACES = {
  TEMPLATE: 'template',
  INVITE: 'invite',
  SHARE: 'share',
  SHARE_AUTH: 'share_auth',
  CREATE_WORKSPACE: 'create_workspace',
  OAUTH: 'oauth',
  PRICING: 'pricing'
} as const
